import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";

import { GET_POLICY_PLANS } from "../services/get-policy-plans";
import { GET_POLICY_TYPE_LIST } from "../services/get-policy-type-list";
import { GET_POLICIES } from "../services/get-policies";
export const SET_POLICY_FIELD = "SET_POLICY_FIELD";
export const RESET_POLICY_SEARCH = "RESET_POLICY_SEARCH";
export const CLEAR_POLICIES = "CLEAR_POLICIES";
export const SET_POLICIES = "SET_POLICIES";
const initialError = {
  code: '',
  message: '',
  value: []
};
export const initialState = {
  policyPlans: [],
  policyTypes: [],
  policies: [],
  total: 0,
  isLoading: false,
  error: initialError,
  dateOfService: "",
  topic: "",
  cptCodes: "",
  icd10: "",
  planInfo: null,
  policyType: "",
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_POLICY_FIELD:
      return {
        ...state,
        [action.field]: action.value,
      };
    case SET_POLICIES:
      return {
        ...state,
        policies: action.data,
        total: action.count ?? action.data?.length ?? 0,
      };

    case RESET_POLICY_SEARCH:
      return {
        ...state,
        dateOfService: "",
        topic: "",
        cptCodes: "",
        icd10: "",
        planInfo: null,
        policyType: "",
        policies: [],
        total: 0,
      };

    case CLEAR_POLICIES:
      return {
        ...state,
        policies: [],
        total: 0,
      };

    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      // ----- POLICY PLANS -----

      if (isAsyncOperation(GET_POLICY_PLANS)(action)) {
        return {
          ...state,
          policyPlans: [],
          isLoading: true,
        };
      }

      if (isAsyncComplete(GET_POLICY_PLANS)(action)) {
        return {
          ...state,
          policyPlans: action?.response || [],
          isLoading: false,
        };
      }
      if (isAsyncFailure(GET_POLICY_PLANS)(action)) {
        return { ...state, isLoading: false, error: action.error };
      }
      // POLICY TYPE LIST
      if (isAsyncOperation(GET_POLICY_TYPE_LIST)(action)) {
        return {
          ...state,
          policyTypes: [],
          isLoading: true,
        };
      }

      if (isAsyncComplete(GET_POLICY_TYPE_LIST)(action)) {
        return {
          ...state,
          policyTypes: action.response || [],
          isLoading: false,
        };
      }
      if (isAsyncFailure(GET_POLICY_TYPE_LIST)(action)) {
        return { ...state, isLoading: false, error: action.error };
      }
      // ---- GET POLICIES ----
      if (isAsyncOperation(GET_POLICIES)(action)) {
        return {
          ...state,
          policies: [],
          isLoading: true,
        };
      }

      if (isAsyncComplete(GET_POLICIES)(action)) {
        return {
          ...state,
          policies: action.response?.data || [],
          total: action.response?.count || 0,
          isLoading: false,
        };
      }
      if (isAsyncFailure(GET_POLICIES)(action)) {
        return { ...state, isLoading: false, error: action.error };
      }

      return state;

    default:
      return state;
  }
}
